module.exports = __webpack_public_path__ + "static/name-9798d5471b786cce7589bd7e9ffd6c21.png";